class OrderSummary {
 
    constructor() {
        this.subtotalElem = document.getElementById("subtotal-amount");
        this.savingsElem = document.getElementById("savings-amount");
        this.shippingElem = document.getElementById("shipping-amount");
        this.estimatedTotalElem = document.getElementById("estimated-total");
        this.savingsContainer = document.getElementById("savings-container");
        this.miniCartContainer = document.getElementById("mini-cart-summary");
        this.toggleSummaryBtn = document.getElementById("toggle-summary-details");
        this.orderSummaryContent = document.getElementById("order-summary-content");
        this.totalPriceContainers = document.querySelectorAll(".total-price");
        this.itemDiscountCodeContainers = document.querySelectorAll(".item-coupon-codes");
        this.discountCodeContainer = document.querySelector(".discount-code-container");
        this.appDtcUrl = "https://app-dtc-utility-qa.sdlc.app.cbrands.com/coupons";
        this.flatRate = window.OrderSummaryConfig?.flatRate || 0;
        this.cartTotal=0; 
        this.cart={};
        this.isManualDiscountUpdate = false;
        this.showAutomaticDiscountMessage=false;
        this.init();
    }

    /** 
     * init the event listeners and fetch cart
     */
    init() {
        this.fetchCart(); 
        document.addEventListener("cart:updated", async (event) => {
            this.isManualDiscountUpdate = event.detail?.isManualDiscount || false;
            this.restoreReferences();

            const fetching =await this.fetchCart();
            const refreshCoupons=await discountManagerInstance.refreshDiscounts();
            if(!this.isManualDiscountUpdate && !this.showAutomaticDiscountMessage)
            {
            const discountMessage=document.querySelector('.discount-message');
            if(discountMessage)   discountMessage.innerText=""; 
            const discCodeContainer= document.getElementById('discount-code');
             if(discCodeContainer) {
                discCodeContainer.classList.remove('has-error');
                discCodeContainer.setAttribute('aria-invalid', 'false');
             }
            }
            this.showAutomaticDiscountMessage=false;

        });
        document.addEventListener("cart:ShippingIncluded", () => this.ShippingIncluded());
        document.addEventListener('click', (event) => { 
            if (event.target.id === "toggle-summary-details") {
            this.toggleOrderSummary();
            }
        });
    }

    /**
     * Restore references to DOM elements after cart is updated
     */
    restoreReferences() {
        this.subtotalElem = document.getElementById("subtotal-amount");
        this.savingsElem = document.getElementById("savings-amount");
        this.shippingElem = document.getElementById("shipping-amount");
        this.estimatedTotalElem = document.getElementById("estimated-total");
        this.savingsContainer = document.getElementById("savings-container");
        this.miniCartContainer = document.getElementById("mini-cart-summary");
        this.toggleSummaryBtn = document.getElementById("toggle-summary-details");
        this.orderSummaryContent = document.getElementById("order-summary-content");
        this.totalPriceContainers = document.querySelectorAll(".total-price");
        this.itemDiscountCodeContainers = document.querySelectorAll(".item-coupon-codes");
        this.discountCodeContainer = document.querySelector(".discount-code-container"); 
    }

    /**
     * Fetch cart data
     */
    async fetchCart() {
        try {
            const response = await fetch("/cart.js");
            if (!response.ok) throw new Error("Failed to fetch cart data");
            const cart = await response.json();
            this.cart=cart;
            this.cartTotal=cart.total_price;
            updateCartCounter(cart.item_count);
            this.updateDiscountAndTotalPerItem(cart);
            this.updateItemCouponCodes(cart);
            this.updateOrderSummary(cart);
        } catch (error) {
            console.error("Error fetching cart:", error);
        }
    }

    /**
    * Update the item discount codes in the cart
    */
    updateItemCouponCodes(cart) {
       this.itemDiscountCodeContainers.forEach((container) => {
           container.innerHTML = "";
           const itemId = container.dataset.code;
           const item = cart.items.find((item) => item.id.toString() === itemId.toString());
           if (item && item.discounts && item.discounts.length > 0) {
               item.discounts.forEach(code => {
                   const couponBox = document.createElement("div");
                   const discountAmount = this.formatAmount(code.amount);
                   couponBox.className = "coupon-box";
                   couponBox.innerHTML = `${code.title} (-${discountAmount})`;
                   container.appendChild(couponBox);
               });
           }
       });
   }

   /**
    * Update the total and total with discount per item in the cart
    */
   updateDiscountAndTotalPerItem(cart) {
       cart.items.forEach((item) => {
           const discountValue = document.getElementById(`discount-price-${item.id}`);
           const totalPrice = document.getElementById(`total-price-${item.id}`);
           if (discountValue && item.total_discount === 0) {
               discountValue.remove();
           } else if (discountValue && item.total_discount > 0) {
               // Update the crossed-value discount for the item
               const newDiscount = this.formatAmount(item.original_line_price);
               discountValue.innerHTML = newDiscount;
           } else if (!discountValue && item.total_discount > 0) {
               // Add the crossed-value discount for the item
               const newDiscount = this.formatAmount(item.original_line_price);
               const parentTotalPrice = document.getElementById(`total-price-${item.id}`).parentNode;
               const discountBox = document.createElement("span");
               discountBox.id = `discount-price-${item.id}`;
               discountBox.className = "discount-price";
               discountBox.innerHTML = `${newDiscount}`;
               parentTotalPrice.insertBefore(discountBox, totalPrice);
           }
           // Update the total price with the discount, if applicable
           const newTotal = this.formatAmount(item.line_price);
           totalPrice.innerHTML = `${newTotal}`;
       });
   }

   /**
    * Update the order summary 
    */
    updateOrderSummary(cart) {
        if (!cart || cart.item_count === 0) {
            console.log("change discount")
            this.miniCartContainer.style.display = "none";
            const CBICartBody = document.querySelector('.cbi-cart_body');
            const CBICartEmptyText = document.querySelector('.cbi-cart_empty-text');
            const CBICartButtonContainer = document.querySelector('.cbi-cart_button-container');
            const cartProductList = document.querySelector('.cart-product-list');
            if (CBICartBody) CBICartBody.style.display = "block";
            if (CBICartEmptyText) CBICartEmptyText.style.display = "block";
            if (CBICartButtonContainer) CBICartButtonContainer.style.display = "flex";
            if (cartProductList) cartProductList.style.display = "none";
            localStorage.setItem('totalDiscount', 0);
            // new ShippingProgress(0); // Ensure progress bar resets
            return;
        }
        if (document.querySelector('.cbi-cart_empty-text')) {
            document.querySelector('.cbi-cart_body').style.display = "none";
            document.querySelector('.cbi-cart_empty-text').style.display = "none";
            document.querySelector('.cbi-cart_button-container').style.display = "none";
            document.querySelector('.cart-product-list').style.display = "block";
        }
        this.miniCartContainer.style.display = "block";
        this.updateSubtotal(cart);
        this.updateSavings(cart);
        this.updateShipping(cart);
        this.updateEstimatedTotal(cart);

        // Recalculate and update the shipping progress bar
        // const bottleCount = cart.items.reduce((count, item) => count + item.quantity, 0);
        // new ShippingProgress(bottleCount);
    }

  

    /**
     * update the subtotal value.
     */
    updateSubtotal(cart) {
        this.subtotalElem.innerText = this.formatAmount(cart.original_total_price);
    }

    /**
     * Update the total savings value.
    */
    updateSavings(cart) {
        if (cart.total_discount > 0) {
            this.savingsElem.innerText = `${this.formatAmount(cart.total_discount)}`;
            this.savingsContainer.style.display = "flex"; 
            const totalDiscount = localStorage.getItem('totalDiscount');
            if ((totalDiscount == 0 || totalDiscount ==null) && cart.total_discount > 0 && !this.isManualDiscountUpdate) {
                localStorage.setItem('totalDiscount',cart.total_discount);   
                const couponFeedbackElem = document.querySelector('.coupon-feedback') || document.querySelector('.discount-message'); 
                this.showAutomaticDiscountMessage=true;
                if (couponFeedbackElem) { 
                    couponFeedbackElem.innerText = `An automatic discount has been applied to your cart.`;
                    couponFeedbackElem.className = `discount-message success`;
                }
            } else {
                localStorage.setItem('totalDiscount', cart.total_discount); 
            }
        } else {
            this.savingsContainer.style.display = "none";
            localStorage.setItem('totalDiscount', 0); 
        }
    } 

    /**
     * estimated shipping cost
     */
    async updateShipping(cart)
    {
        let bottleCount =await this.bottleCount(cart);
        console.log("updating shipping",bottleCount);
        // new ShippingProgress(bottleCount);
        if (bottleCount >= window.OrderSummaryConfig.minBottles && window.OrderSummaryConfig.shippingEnabled) {
            OrderSummary.updateShippingText("Included");
        }
        else if (bottleCount >= 0) {
            const exist=await discountManagerInstance.checkFreeShippingCodeExists()
            if(exist)
            {
                OrderSummary.updateShippingText("Included");
            }
            else{
                const flatRate = window.OrderSummaryConfig.flatRate;
                if (!flatRate || flatRate === "" || flatRate === "TBD"|| flatRate == 0) {
                    OrderSummary.updateShippingText("TBD");
                    return;
                } else {
                    OrderSummary.updateShippingText(`$${flatRate}`);
                    this.updateEstimatedTotal(cart, true);
                }
            }
        } else {
            OrderSummary.updateShippingText("-");
        }
    }

    /**
     * Updates the estimated total cost
     */
    async updateEstimatedTotal(cart,withFlatRate=false) {
        let estimatedTotal = cart.total_price;
        if (withFlatRate) { 
            estimatedTotal += (this.flatRate * 100);
        }
        this.estimatedTotalElem.innerText = this.formatAmount(estimatedTotal);
    }

    /*
    update shipping text
    */ 
    static updateShippingText(text) {
        const shippingElem = document.getElementById("shipping-amount");
        if(text =="Included")
        {
            shippingElem.classList.add('shipping-included')

        }else{
            shippingElem.classList.remove('shipping-included')

        }
        shippingElem.innerText = text; 
    }

    /**
     * Shipping included function
     */
    ShippingIncluded()
    {
        OrderSummary.updateShippingText("Included");
        const estimatedTotal = this.cartTotal;
        this.estimatedTotalElem.innerText=this.formatAmount(estimatedTotal)
    }

    /**  
    * Get the bottle qty (to calculate the estimated shipping)
    */
    async bottleCount(cart) {
        let bottleCount = 0;
        try {
            const store = Shopify.shop.replace(".myshopify.com", "") 
            const response = await fetch(`${this.appDtcUrl}/get-bottle-qty`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ store, cartId:`gid://shopify/Cart/${cart.token}` }),
            });
            if (!response.ok) {
                console.error(` Failed to fetch bottle count: ${response.statusText}`);
                return 0;
            }
            const result = await response.json();
            if (result) {
                bottleCount=result.totalBottleQty;
            }

            return bottleCount;  
        } catch(error) {
            return 0;
        }
    }

    /**
    * Format the amount to a currency string
    */
    formatAmount(amount) {
        return `$${(amount / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    }

    /*
    * toggleOrderSummary
    */
    toggleOrderSummary() {
        if (this.orderSummaryContent.style.display === "none" || this.orderSummaryContent.style.display === "") {
            this.orderSummaryContent.style.display = "block";
            this.discountCodeContainer.style.display = "block";
            this.toggleSummaryBtn.classList.add('active-summary')
        } else {
            this.orderSummaryContent.style.display = "none";
            this.discountCodeContainer.style.display = "none";
            this.toggleSummaryBtn.classList.remove('active-summary')
        }
    }
}

// inti the OrderSummary class 
document.addEventListener("DOMContentLoaded", () => new OrderSummary());


class DiscountManager {
    constructor() {
        this.discountInput = document.getElementById("discount-code");
        this.applyDiscountBtn = document.getElementById("apply-discount");
        this.couponFeedback = document.querySelector('.coupon-feedback');
        this.discountContainer = document.querySelector('.coupon-codes');
        this.appDtcUrl = "https://app-dtc-utility-qa.sdlc.app.cbrands.com/coupons";
        this.appliedDiscounts = [];
        this.feeshipingIncluded=false;
        this.store = Shopify.shop.replace(".myshopify.com", "")  
        this.init();
    }

    async init() {
        document.addEventListener("cart:add", async () => {
            this.restoreReferences();
            await this.applyDiscountListeners();
        });
        await this.applyDiscountListeners();
    }

    /**
     * Restore references to DOM elements after a product is added from outside the cart
     */
    restoreReferences() {
        this.discountInput = document.getElementById("discount-code");
        this.applyDiscountBtn = document.getElementById("apply-discount");
        this.couponFeedback = document.querySelector('.coupon-feedback');
        this.discountContainer = document.querySelector('.coupon-codes');
    }

    /**
     * Get the cart id
    */
    async getCartId() {
        try {
            const response = await fetch("/cart.js");
            if (!response.ok) throw new Error("Failed to fetch cart data.");
            const cartData = await response.json();
            return "gid://shopify/Cart/" + cartData.token || null;
        } catch (error) {
            console.error("Error fetching cart ID:", error);
            return null;
        }
    }

    /**
     * Apply discount listeners
     */
    async applyDiscountListeners() {
        if (this.applyDiscountBtn) {
            this.applyDiscountBtn.addEventListener("click", () => this.applyDiscount());
            await this.getAppliedDiscounts();
            this.displayCheckoutCodes(this.appliedDiscounts);
            this.discountInput.addEventListener("keydown", (event) => this.handleDiscountKeypress(event));
        }
    }

    /**
     * send discount code cart id and store  to backend
     */
    async applyDiscount() {
        const discountCode = this.discountInput.value.trim();
        this.discountInput.classList.remove('has-error');
        this.discountInput.setAttribute('aria-invalid', 'false');
        if (!discountCode) {
            this.displayMessage("Please enter a discount code.", "error");
            this.discountInput.classList.add('has-error');
            this.discountInput.setAttribute('aria-invalid', 'true');
            return;
        }
        this.applyDiscountBtn.disabled = true;
        // this.displayMessage("applying ...", "info");

        try {
            const cartId = await this.getCartId();
            if (!cartId) {
                this.displayMessage("cart id not found.", "error");
                this.applyDiscountBtn.disabled = false;
                this.discountInput.classList.add('has-error');
                this.discountInput.setAttribute('aria-invalid', 'true');
                return;
            }
            const store = this.store;
            const currentCodes = this.appliedDiscounts.map(d => d.code.toLowerCase());
           
            if (currentCodes.includes(discountCode.toLowerCase())) {
                this.displayMessage(`Discount "${discountCode}" is already applied.`, "error");
                this.applyDiscountBtn.disabled = false;
                this.discountInput.classList.add('has-error');
                this.discountInput.setAttribute('aria-invalid', 'true');
                return;
            }

            const updatedDiscounts = [...currentCodes, discountCode];

            const response = await fetch(`${this.appDtcUrl}/apply-coupon`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ store, cartId, discountCode: updatedDiscounts }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error("failed to apply discount.");
            }
            this.discountInput.value = "";

            const discount = result.discountCodes.find(d => d.code.toLowerCase() === discountCode.toLowerCase());

            this.appliedDiscounts = result.discountCodes
                .filter(d => d.applicable);
                // .map(d => d.code.toLowerCase());
            this.displayCheckoutCodes(this.appliedDiscounts); 
            if (!discount) { 
                this.displayMessage(`"${discountCode}" discount code isn’t valid for the items in your cart.`, "error");
                return;
            }
            if(discount.status=="SCHEDULED" )
            {
                this.displayMessage(` Discount "${discountCode}" is not available!`, "error"); 
                this.discountInput.classList.add('has-error');
                this.discountInput.setAttribute('aria-invalid', 'true');
            }else
            {  
                if (discount.applicable) {
                    // this.displayMessage(` Discount "${discountCode}" applied successfully!`, "success");
                    this.discountInput.classList.remove('has-error');
                    this.discountInput.setAttribute('aria-invalid', 'false');
                } else if (!discount.exist) {
                    this.displayMessage(`Enter a valid discount code.`, "error");
                    this.discountInput.classList.add('has-error');
                    this.discountInput.setAttribute('aria-invalid', 'true');
                } else{
                    this.checkCombination(discount,result.discountCodes);
                }
            }

            document.dispatchEvent(new CustomEvent("cart:updated", {
                detail: {
                    isManualDiscount: true
                }}));
        } catch (error) {
            console.error("Error applying discount:", error);
            this.displayMessage(error.message, "error");
        } finally {
            this.applyDiscountBtn.disabled = false;
        }
    }


    /**
    * Check the Disount Code comibination
    */ 
    checkCombination(currentCode, codes)
    {
        let  appliedCodes = codes.filter((dis)=>{ return dis.code != currentCode.code && dis.applicable == true})
        let hasConflicts=false;
        for (const code of appliedCodes) 
        {
            if(code.discountClass==="ORDER" && currentCode.combinesWith['orderDiscounts']==false)
            {
                hasConflicts=true;
            } 
            if(code.discountClass==="PRODUCT" && currentCode.combinesWith['productDiscounts']==false)
            {
                hasConflicts=true;
            } 
            if((code.discountClass==="SHIPPING" && currentCode.combinesWith['shippingDiscounts']==false) )
            {
                hasConflicts=true;
            }  
            if(currentCode.discountClass==="ORDER" && code.combinesWith['orderDiscounts']==false)
            {
                hasConflicts=true;
            } 
            if(currentCode.discountClass==="PRODUCT" && code.combinesWith['productDiscounts']==false)
            {
                hasConflicts=true;
            } 
            if((currentCode.discountClass==="SHIPPING" && code.combinesWith['shippingDiscounts']==false) )
            {
                hasConflicts=true;
            }   
        }
        if (hasConflicts) {
            this.displayMessage(`"${currentCode.code}" couldn't be used with your existing discounts.`, "error");
            this.discountInput.classList.add('has-error');
            this.discountInput.setAttribute('aria-invalid', 'true');
        } else {
            this.displayMessage(`"${currentCode.code}" discount code isn't valid for the items in your cart.`, "error");
            this.discountInput.classList.add('has-error');
            this.discountInput.setAttribute('aria-invalid', 'true');
        }

    }


    /**
    * get the applied discounts
    */ 
    async getAppliedDiscounts() {
        const cartId = await this.getCartId();
        const store = this.store;
        const response = await fetch(`${this.appDtcUrl}/get-applied-discounts`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ store, cartId })
        });

        const result = await response.json();


        if (!response.ok || !result.discountCodes) {
            throw new Error("Failed to fetch applied discounts.");
        }
        else {
            this.appliedDiscounts = result.discountCodes
                .filter(d => d.applicable);
                // .map(d => d.code.toLowerCase());
        }

    }

    /**
    * displays applying coupon feedback
    */
    async removeDiscount(discountCode) {
        try {
            this.displayMessage("", "error");
            const cartId = await this.getCartId();
            const store = this.store;
            const discountCodes = this.appliedDiscounts.filter(d => d.code != discountCode)
                .map(d => d.code.toLowerCase());

            const response = await fetch(`${this.appDtcUrl}/remove-discount`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ store, cartId, discountCodes })
            });

            const result = await response.json();

            if (!response.ok || result.error) {
                throw new Error(result.error || "Failed to remove discount.");
            }
            else {
                this.appliedDiscounts = result.cart.discountCodes
                    .filter(d => d.applicable);
                    // .map(d => d.code.toLowerCase());
                this.displayCheckoutCodes(this.appliedDiscounts)
                document.dispatchEvent(new Event("cart:updated"));
            }


        } catch (error) {
            console.error("Error removing discount:", error);
        }
    }

    /**
     * displays applying coupon feedback
     */
    displayMessage(message, type) {
        this.couponFeedback.innerText = message;
        this.couponFeedback.className = `discount-message ${type}`;
    }

    /**
      * display discount UI boxes
    */
    displayCheckoutCodes(discountCodes) {
        if (!this.discountContainer) return;
        let freeship=false;
        this.discountContainer.innerHTML = "";
        discountCodes.forEach(discount => {
            if(discount.type == 'DiscountCodeFreeShipping' || (discount.discountClass=='SHIPPING' && discount.type=="DiscountCodeApp"))
                {
                freeship=true;
            }
            const couponBox = document.createElement("div");
            couponBox.className = "coupon-box";
            couponBox.innerHTML = `
                <span>${discount.code}</span>
                <button class="remove-discount" data-code="${discount.code}">
                    <svg width="8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                    </svg>
                </button>
            `;
            this.discountContainer.appendChild(couponBox);
        });
        document.querySelectorAll(".remove-discount").forEach(btn => {
            btn.addEventListener("click", (event) => this.removeDiscount(event.target.closest(".remove-discount").dataset.code));
        });

        this.feeshipingIncluded=freeship;
        if(this.feeshipingIncluded)
        {
            setTimeout(function(){
                console.log(this.appliedDiscounts);
                document.dispatchEvent(new Event("cart:ShippingIncluded"));
            },1000)
          
        }
    }

    handleDiscountKeypress(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            event.preventDefault();
            if (this.discountInput.value.trim()) {
                this.applyDiscount();
            }
        }
    }

    async refreshDiscounts() {
        const appliedDiscounts = await this.getAppliedDiscounts(); 
        this.displayCheckoutCodes(this.appliedDiscounts);
    }

    async checkFreeShippingCodeExists(){
       
        const freeShippingCode = this.appliedDiscounts.find(discount => discount.type === 'DiscountCodeFreeShipping');
        return !!freeShippingCode;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    window.discountManagerInstance = new DiscountManager();
});

// progress Bar
class ShippingProgress {
    constructor( bottleQty) { 
      this.minBottles = window.OrderSummaryConfig.minBottles;
      this.progress = 5;
      this.update(bottleQty);
    }

    update(bottleQty) {
      this.bottleQty = bottleQty;
      this.updateUI();
    }
  
    calculateProgress() {
      let numberOfProducts = 0;
      this.numberOfProducts = this.bottleQty;
  
      if (numberOfProducts === 0) {
        this.progress = 5;
      } else {
        this.progress = (numberOfProducts / this.minBottles) * 100;
      }
    }
  
    updateProgressBar() {
        const progressBar = document.getElementById('carrot-progress');
        console.log('progressBar', progressBar)
        if (progressBar) {
          const percent =(this.bottleQty/this.minBottles)*100;
          progressBar.style.width = `${percent> 0 ? percent:3}%`;
        }
      }
  
    updateUI() {
      this.calculateProgress();
      this.updateProgressBar();
     
  
      const restForFreeShipping = this.minBottles - this.numberOfProducts; 
     
      if (restForFreeShipping > 0) {
        const bottlesElement = document.getElementById('bottles-to-qualify');
        if (bottlesElement) { 
          bottlesElement.innerText = `${restForFreeShipping}`;
        }
        document.getElementById('carrot-progress')?.classList.remove('shipping-progress_carrot-progress-complete');
        document.getElementById('shipping-progress')?.removeAttribute('hidden');
        console.log("showing progress bar");
        document.getElementById('free-shipping')?.setAttribute('hidden',true);
      } else {
        document.getElementById('carrot-progress')?.classList.add('shipping-progress_carrot-progress-complete');
        document.getElementById('shipping-progress')?.setAttribute('hidden', true);
        document.getElementById('free-shipping')?.removeAttribute('hidden');
      }
    }
  }
